import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress} from "@material-ui/core";

const DeleteDialog = (props) => {
    const {open, onClose, loading, submitCallback} = props

    const handleCloseDialog = () => {
        onClose()
    }

    const handleSubmitDialog = async () => {
        await submitCallback()
        onClose()
    }

    return (
        <Dialog open={open} onClose={handleCloseDialog} maxWidth={"xs"} fullWidth>
            <DialogTitle>Вы уверены?</DialogTitle>
            <DialogContent>
                <LinearProgress hidden={!loading}/>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog} disabled={loading}>Отмена</Button>
                <Button onClick={handleSubmitDialog} disabled={loading}>Удалить</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteDialog;